<template>
  <div class="dashboard">
    <confirm ref="confirm"></confirm>
    <v-progress-linear v-show="progressBar" slot="progress" color="blue" indeterminate />

    <v-layout row Wrap>
      <v-flex xs12 sm12 lg12>
        <v-card-text >
          <div class="subtitle-1 grey--text" v-text="PageTitle" >
          </div>
        </v-card-text>
      </v-flex>
    </v-layout>

    <v-container class="bg-surface-variant" >
      <v-row no-gutters>
        <v-col cols="12" lg="4" md="6" sm="12" v-if="this.curprofile == 'CRA'">
          <v-sheet class="ma-2 pa-2">
            <v-card :loading="loading" class="mx-auto my-12" max-width="374">
              <v-card-title>Premium Subscribers</v-card-title>
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <div class="my-4 text-subtitle-1" v-text="PremAct" >
                </div>
              </v-card-text>
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <div class="my-4 text-subtitle-1" v-text="PremSusp" >
                </div>
              </v-card-text>
            </v-card>
          </v-sheet>
        </v-col>

        <v-col cols="12" lg="4" md="6" sm="12" v-if="this.curprofile == 'CRA'">
          <v-sheet class="ma-2 pa-2">
            <v-card :loading="loading" class="mx-auto my-12" max-width="374">
              <v-card-title>Individual Subscribers</v-card-title>
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <div class="my-4 text-subtitle-1" v-text="IndAct" >
                </div>
              </v-card-text>
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <div class="my-4 text-subtitle-1" v-text="IndSusp" >
                </div>
              </v-card-text>
            </v-card>
          </v-sheet>
        </v-col>

        <v-col cols="12" lg="4" md="6" sm="12" v-if="this.curprofile == 'CRA' || this.curprofile == 'IRR' ">
          <v-sheet class="ma-2 pa-2">
            <v-card :loading="loading" class="mx-auto my-12" max-width="374">
              <v-card-title>Companies & Audience</v-card-title>
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <div class="my-4 text-subtitle-1" v-text="AllActComp" >
                </div>
              </v-card-text>
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <div class="my-4 text-subtitle-1" v-text="SubAud" >
                </div>
              </v-card-text>
            </v-card>
          </v-sheet>
        </v-col>

      </v-row>
    </v-container>




  </div>
</template>

<script>
// @ is an alias to /src
import Confirm from "@/components/Confirm";

export default {
  watch: {
    $route() {
      this.refreshlist();
    },
  },

  components: { Confirm },
  data() {
    return {
      PageTitle: localStorage.getItem("CURPROFILE") + " - Dashboard",
      curprofile: localStorage.getItem("CURPROFILE").trim(),
      PremAct: '',
      PremSusp: '',
      IndAct: '',
      IndSusp: '',
      AllActComp: '',
      SubAud: '',
    };
  },

  created() {
    this.refreshlist();
  },

  mounted() {
    this.refreshlist();
  },

  methods: {

    async refreshlist() {
      this.progressBar = true;

      if (this.curprofile == 'CRA' || this.curprofile == 'IRR'){

      this.myJsonResp = await this.PostData(
        "Dashboard",
        JSON.stringify({
          curprofile: this.curprofile,
        })
      );

      this.progressBar = false;
      
      if (this.myJsonResp != "ERROR") {
        this.loadformfields = false;
        this.data = JSON.parse(this.myJsonResp);
        this.PremAct = "•  " + this.data["PremAct"] + " Active ";
        this.PremSusp = "•  " + this.data["PremSusp"] + " Suspended ";
        this.IndAct = "•  " + this.data["IndAct"] + " Active ";
        this.IndSusp = "•  " + this.data["IndSusp"] + " Suspended ";
        this.AllActComp = "•  " + this.data["AllActComp"] + " Active Companies/Individuals ";
        this.SubAud = "•  " + this.data["SubAud"] + " Subscribed Audience ";
      }
    } else {
       this.progressBar = false;
    }
    },

    async submit() {
      if (
        await this.$refs.confirm.open(
          "Delete",
          "Are you sure gfadgdf gd  gd gd gd gd g gd ggd g ?",
          "",
          "Bro",
          { color: "error" }
        )
      ) {
        // yes
      } else {
        // cancel
      }
    },
  },
};
</script>

